import { render, staticRenderFns } from "./WalletHistoryMetas.vue?vue&type=template&id=7a8a0e9f&"
import script from "./WalletHistoryMetas.vue?vue&type=script&lang=js&"
export * from "./WalletHistoryMetas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports